/* GENERATED by build_abs_size_compare.py from _abs_fit_map.json (2026-09-27) - do not hand-edit. */
window.ABS_FIT = {"standards":{"doorHeader":80,"eye":57,"widthMin":0.66,"widthMax":0.85},"sizes":{"24x18":{"w":24,"h":18,"cm":[61,46],"obj":"wk-side","gap":6,"centre":51.4,"top":60.4,"pct":75},"36x27":{"w":36,"h":27,"cm":[91,69],"obj":"ws-console","gap":8,"centre":56.7,"top":70.2,"pct":75},"48x36":{"w":48,"h":36,"cm":[122,91],"obj":"upbeat-sofa","gap":8,"centre":61.7,"top":79.7,"pct":76},"60x45":{"w":60,"h":45,"cm":[152,114],"obj":null,"bare":true,"centre":57,"top":79.5,"bottom":34.5},"20x30":{"w":20,"h":30,"cm":[51,76],"obj":"upbeat-bedside","gap":6,"centre":41.8,"top":56.8,"pct":83},"24x36":{"w":24,"h":36,"cm":[61,91],"obj":"wk-side","gap":6,"centre":60.4,"top":78.4,"pct":75},"32x48":{"w":32,"h":48,"cm":[81,122],"obj":"ws-chest","gap":8,"centre":55.6,"top":79.6,"pct":80},"40x60":{"w":40,"h":60,"cm":[102,152],"obj":null,"bare":true,"centre":50,"top":80,"bottom":20},"30x20":{"w":30,"h":20,"cm":[76,51],"obj":"ws-headboard","gap":8,"centre":66.4,"top":76.4,"pct":72},"36x24":{"w":36,"h":24,"cm":[91,61],"obj":"ws-console","gap":8,"centre":55.2,"top":67.2,"pct":75},"48x32":{"w":48,"h":32,"cm":[122,81],"obj":"upbeat-sofa","gap":8,"centre":59.7,"top":75.7,"pct":76},"60x40":{"w":60,"h":40,"cm":[152,102],"obj":null,"bare":true,"centre":57,"top":77,"bottom":37},"24x24":{"w":24,"h":24,"cm":[61,61],"obj":"wk-side","gap":6,"centre":54.4,"top":66.4,"pct":75},"32x32":{"w":32,"h":32,"cm":[81,81],"obj":"ws-bench","gap":8,"centre":55.2,"top":71.2,"pct":76},"40x40":{"w":40,"h":40,"cm":[102,102],"obj":"ws-diwan","gap":8,"centre":59.6,"top":79.6,"pct":79},"48x48":{"w":48,"h":48,"cm":[122,122],"obj":null,"bare":true,"centre":56,"top":80,"bottom":32},"42x18":{"w":42,"h":18,"cm":[107,46],"obj":"wk-diwan","gap":8,"centre":52,"top":61,"pct":71},"56x24":{"w":56,"h":24,"cm":[142,61],"obj":null,"bare":true,"centre":57,"top":69,"bottom":45},"70x30":{"w":70,"h":30,"cm":[178,76],"obj":null,"bare":true,"centre":57,"top":72,"bottom":42},"84x36":{"w":84,"h":36,"cm":[213,91],"obj":null,"bare":true,"centre":57,"top":75,"bottom":39},"18x24":{"w":18,"h":24,"cm":[46,61],"obj":"upbeat-bedside","gap":7.2,"centre":40,"top":52,"pct":75},"27x36":{"w":27,"h":36,"cm":[69,91],"obj":"wk-side","gap":6,"centre":60.4,"top":78.4,"pct":84},"36x48":{"w":36,"h":48,"cm":[91,122],"obj":"am-sandook","gap":8,"centre":54.8,"top":78.8,"pct":75},"45x60":{"w":45,"h":60,"cm":[114,152],"obj":null,"bare":true,"centre":50,"top":80,"bottom":20}},"objects":{"wk-side":{"label":"teak side table","w":32,"h":36.4,"back":32,"seen":"seated / from the bed"},"ws-console":{"label":"carved console table","w":48,"h":35.2,"back":48,"seen":"standing, in passing"},"upbeat-sofa":{"label":"3-seater sofa","w":84,"h":35.7,"back":63,"seen":"standing and seated opposite"},"upbeat-bedside":{"label":"bedside table","w":24,"h":20.8,"back":24,"seen":"seated / from the bed"},"ws-chest":{"label":"carved chest","w":40,"h":23.6,"back":40,"seen":"standing, in passing"},"ws-headboard":{"label":"carved wooden bed","w":60,"h":48.4,"back":41.5,"seen":"standing; rarely from the bed"},"ws-bench":{"label":"carved wooden bench","w":48,"h":31.2,"back":42.1,"seen":"standing, in passing"},"ws-diwan":{"label":"carved wooden diwan","w":72,"h":31.6,"back":50.9,"seen":"standing and seated opposite"},"wk-diwan":{"label":"teak cane diwan","w":72,"h":35,"back":59.5,"seen":"standing and seated opposite"},"am-sandook":{"label":"wooden sandook chest","w":48,"h":22.8,"back":48,"seen":"standing, in passing"}}};
/* abs-size-compare.js - Art by Sandhya size compare block, drawn in the browser at true scale.
 *
 * ABS OWN COPY (2026-09-27). Derived from the TGOA method, not shared with it: its own data
 * (window.ABS_FIT from _abs_fit_map.json), its own palette, a STRETCHED-canvas mount (what ABS
 * sells by default), and BARE-WALL pieces for sizes no furniture can take under the door header.
 *
 * WHY THIS IS DRAWN AND NOT A PICTURE. A product sells three or four sizes out of the twenty-three
 * in the catalogue ladder. A pre-rendered slide either shows all of them - twenty of which are not
 * for sale on this page - or needs one file per combination. Drawing it means the block always
 * shows exactly what the page sells, and costs three furniture cut-outs.
 *
 * ONE SCALE, OR IT IS NOT EVIDENCE. Every rectangle, the figure and every cut-out are placed in a
 * viewBox whose unit IS one inch. There is no per-item scaling anywhere below, which is the only
 * reason the comparison can be trusted. If you add something here, give it a real size in inches
 * and let the viewBox do the work.
 *
 * THE CAPTIONS ARE HTML, NOT SVG TEXT, AND THAT IS THE WHOLE LAYOUT PROBLEM SOLVED.
 * The first cut set the captions in the SVG, in inches like everything else. Two faults, pulling
 * in opposite directions:
 *   - a label sized in inches GROWS on screen when the drawing spans fewer inches, so the same
 *     caption came out 26px on a portrait product and 16px on a panoramic one, and DOOR HEADER
 *     ended up heavier than the drawing it was annotating;
 *   - and once the block was asked to be SMALL, every SVG label shrank with it, towards 9px.
 * A drawing cannot be both compact and carry inch-sized type. So the SVG now draws only the
 * DRAWING, capped at a sensible height, and the captions sit under it in ordinary HTML at ordinary
 * font sizes, positioned at each column's centre as a percentage. They stay readable at any size,
 * they wrap, they are selectable, and a screen reader gets them for free.
 *
 * The few labels that must stay inside the drawing - the datums, the gap - are given their size in
 * PIXELS divided by the scale, so they too come out the same on screen whatever they annotate.
 *
 * The numbers come from window.ABS_FIT, injected from _size_fit_map.json - the same table the
 * rendered ladders were audited against.
 */
(function () {
  "use strict";
  // The snippet carries its own <script src>, so a page with two blocks asks for this file twice
  // and the browser runs it twice - double listeners, double redraws on every resize.
  if (window.__ABS_SC) return;
  window.__ABS_SC = 1;

  var INK = "#1A1A14", MUTE = "#6b675f", ACCENT = "#C24E3A", RULE = "#b9b1a2";
  var WALL = "#F3EDE0", FLOOR = "#E2D8C3", SHEET = "#EAE2D2", FIG = "#cdc6b8", DARK = "#2a241c";
  var MAX_H = 460;   // px. A band of evidence under the buy decision, not a page of its own.
  var MIN_PX = 3.7;  // px per inch below which the size printed on the canvas stops being readable

  function f(n) { return Math.round(n * 100) / 100; }
  function esc(s) { return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"); }
  var IN = "&#8243;", X = "&#215;";

  // 1000 units tall = 72in exactly. Same silhouette as the rendered slides, same reason: a
  // photographic person is a specific person - an age, a build, a decade - and every one of those
  // is a claim about who the product is for that nobody meant to make.
  var FIG_H = 72, FIG_W = 72 * 0.3;
  function figure(x, floorY) {
    var k = FIG_H / 1000;
    return '<g transform="translate(' + f(x) + ',' + f(floorY - FIG_H) + ') scale(' + f(k) + ')" fill="' + FIG + '">' +
      '<ellipse cx="150" cy="62" rx="46" ry="62"/><rect x="136" y="112" width="28" height="34" rx="12"/>' +
      '<ellipse cx="150" cy="176" rx="111" ry="34"/><path d="M 62,150 L 238,150 L 220,520 L 80,520 Z"/>' +
      '<rect x="39" y="152" width="36" height="382" rx="18"/><rect x="225" y="152" width="36" height="382" rx="18"/>' +
      '<rect x="80" y="498" width="140" height="70" rx="24"/>' +
      '<rect x="92" y="540" width="54" height="452" rx="24"/><rect x="154" y="540" width="54" height="452" rx="24"/>' +
      '<rect x="86" y="972" width="66" height="28" rx="8"/><rect x="148" y="972" width="66" height="28" rx="8"/></g>';
  }

  function rect(x, y, w, h, fill) {
    return '<rect x="' + f(x) + '" y="' + f(y) + '" width="' + f(w) + '" height="' + f(h) +
           '" fill="' + fill + '"/>';
  }

  // The two mounts, at their real millimetres. The product page states which one the buyer is
  // getting a few inches above this block; drawing the other would contradict it on sight.
  var MOUNT = { floater: { face: 10 / 25.4, reveal: 8 / 25.4 },
                classic: { face: 15 / 25.4, overlap: 5 / 25.4 } };
  function frame(x, y, w, h, mount) {
    // STRETCHED: an unframed canvas seen face-on - no moulding, only the shadow line of its edge.
    if (mount === "stretched" || mount === "rolled") {
      var e = 0.35;
      return rect(x + e, y + e, w, h, "rgba(0,0,0,0.18)") + rect(x, y, w, h, SHEET);
    }
    if (mount === "classic") {
      var out = MOUNT.classic.face - MOUNT.classic.overlap, ov = MOUNT.classic.overlap;
      return rect(x - out, y - out, w + out * 2, h + out * 2, INK) +
             rect(x + ov, y + ov, w - ov * 2, h - ov * 2, SHEET);
    }
    var band = MOUNT.floater.face + MOUNT.floater.reveal, rv = MOUNT.floater.reveal;
    return rect(x - band, y - band, w + band * 2, h + band * 2, INK) +
           rect(x - rv, y - rv, w + rv * 2, h + rv * 2, DARK) +
           rect(x, y, w, h, SHEET);
  }

  // The size, set in type on the canvas. The one place inches are the right unit for type: this
  // has to FIT the piece it is printed on, so it is a fraction of the piece - with a ceiling, so a
  // 48in canvas does not carry 60px numerals, and a floor, below which the sub-labels are dropped
  // rather than shipped unreadable.
  function sizeOnCanvas(cx, cy, d, scale) {
    var big = Math.min(d.w, d.h) * 0.21;
    if (big * scale > 30) big = 30 / scale;
    var sm = big * 0.40;
    if (sm * scale < 7) sm = 0;
    function t(y, str, size, fill) {
      return '<text x="' + f(cx) + '" y="' + f(y) + '" font-size="' + f(size) + '" fill="' + fill +
             '" text-anchor="middle" font-family="Georgia,serif">' + str + "</text>";
    }
    var s = t(cy + big * 0.18, d.w + " " + X + " " + d.h, big, INK);
    if (sm) {
      s += t(cy + big * 0.18 + sm * 1.6, "inches", sm, MUTE);
      s += t(cy + big * 0.18 + sm * 2.9, d.cm[0] + " " + X + " " + d.cm[1] + " cm", sm * 0.92, MUTE);
    }
    return s;
  }

  function highlight(x, y, w, h, scale) {
    var o = 4 / scale;
    return '<rect x="' + f(x - o) + '" y="' + f(y - o) + '" width="' + f(w + o * 2) + '" height="' +
      f(h + o * 2) + '" fill="none" stroke="' + ACCENT + '" stroke-width="' + f(1.4 / scale) + '"/>';
  }

  /* ---- layout, in inches only. No type, no captions, no scale yet. ------------------ */
  function layoutPerson(list) {
    var PAD = 5, cols = [], x = FIG_W + PAD, i;
    for (i = 0; i < list.length; i++) {
      cols.push({ d: list[i], x: x, w: list[i].w });
      x += list[i].w + PAD;
    }
    return { W: x - PAD, H: FIG_H + 1, floorY: FIG_H, cols: cols, mode: "person" };
  }
  // A LEFT GUTTER FOR THE DATUM LABELS, AND IT IS FREE.
  // With the labels riding on the line at the wall's left edge, "EYE LEVEL 57in" ran straight
  // through the first frame - the one most likely to be the shopper's selected size. A gutter
  // costs width, and width is the one thing this drawing has spare: room mode's height is always
  // the same (the door header, plus a little floor), so the scale is set by MAX_H, not by the
  // container. Until the drawing spans about 240in it is height-bound and 26 more inches of
  // gutter change nothing but where the labels sit.
  var GUT = 34;  // ABS: 26 clipped "DOOR HEADER" on wide (scrolling) panoramic drawings
  function layoutRoom(list, std, objects) {
    var PAD = 9, cols = [], x = GUT, i;
    for (i = 0; i < list.length; i++) {
      var o = list[i].obj ? objects[list[i].obj] : null;
      cols.push({ d: list[i], o: o, x: x, w: o ? Math.max(list[i].w + 2, o.w) : list[i].w + 6 });
      x += cols[i].w + PAD;
    }
    var floorY = std.doorHeader + 5;
    return { W: x - PAD, H: floorY + 1.4, floorY: floorY, cols: cols, mode: "room", std: std };
  }

  /* ---- the drawing ------------------------------------------------------------------ */
  function paint(g, mount, selected, scale, W) {
    var s = "", i, c, cx, off = (W - g.W) / 2, floorY = g.floorY;

    if (g.mode === "room") {
      s += rect(off, 0, g.W, floorY, WALL);
      s += rect(off, floorY, g.W, 1.4, FLOOR);
      // The datum labels ride ON the line rather than in a left gutter. A gutter wide enough for
      // "DOOR HEADER" is a fifth of the drawing's width spent on two words.
      [[g.std.doorHeader, "DOOR HEADER"], [g.std.eye, "EYE LEVEL"]].forEach(function (r) {
        var y = floorY - r[0];
        s += '<line x1="' + f(off + GUT - 3) + '" y1="' + f(y) + '" x2="' + f(off + g.W) + '" y2="' + f(y) +
             '" stroke="' + RULE + '" stroke-width="' + f(1 / scale) + '" stroke-dasharray="' +
             f(5 / scale) + " " + f(4 / scale) + '"/>';
        s += '<text x="' + f(off + GUT - 6) + '" y="' + f(y - 4 / scale) + '" font-size="' + f(10 / scale) +
             '" fill="' + MUTE + '" text-anchor="end" font-family="Helvetica,Arial,sans-serif"' +
             ' font-weight="600" letter-spacing="' + f(1 / scale) + '">' + r[1] + "</text>";
        s += '<text x="' + f(off + GUT - 6) + '" y="' + f(y + 9 / scale) + '" font-size="' + f(10 / scale) +
             '" fill="' + RULE + '" text-anchor="end" font-family="Helvetica,Arial,sans-serif"' +
             ' font-weight="600">' + r[0] + IN + "</text>";
      });
    } else {
      s += figure(off, floorY);
      s += '<line x1="' + f(off) + '" y1="' + f(floorY) + '" x2="' + f(off + g.W) + '" y2="' +
           f(floorY) + '" stroke="' + INK + '" stroke-width="' + f(1.2 / scale) + '"/>';
      s += '<text x="' + f(off + FIG_W / 2) + '" y="' + f(floorY - 2.5 / scale) + '" font-size="' +
           f(10.5 / scale) + '" fill="' + MUTE + '" text-anchor="middle" font-weight="600"' +
           ' font-family="Helvetica,Arial,sans-serif">6 FT</text>';
    }

    for (i = 0; i < g.cols.length; i++) {
      c = g.cols[i];
      cx = off + c.x + c.w / 2;
      var d = c.d;
      var top = g.mode === "room" ? floorY - d.top : floorY - d.h;
      if (g.mode === "room" && c.o) {
        s += '<image href="' + c.o.src + '" x="' + f(cx - c.o.w / 2) + '" y="' + f(floorY - c.o.h) +
             '" width="' + f(c.o.w) + '" height="' + f(c.o.h) + '" preserveAspectRatio="none"/>';
        s += '<line x1="' + f(cx) + '" y1="' + f(top + d.h) + '" x2="' + f(cx) + '" y2="' +
             f(top + d.h + d.gap) + '" stroke="' + ACCENT + '" stroke-width="' + f(1 / scale) + '"/>';
        s += '<text x="' + f(cx + 2) + '" y="' + f(top + d.h + d.gap / 2 + 3.5 / scale) +
             '" font-size="' + f(10.5 / scale) + '" fill="' + ACCENT + '" font-weight="600"' +
             ' font-family="Georgia,serif">' + Math.round(d.gap) + IN + " gap</text>";
      }
      s += frame(cx - d.w / 2, top, d.w, d.h, mount);
      s += sizeOnCanvas(cx, top + d.h / 2, d, scale);
      if (d.size === selected) s += highlight(cx - d.w / 2, top, d.w, d.h, scale);
      c.pct = (cx - off) / g.W * 100;
      c.wpct = c.w / g.W * 100;
    }
    return s;
  }

  /* ---- captions, in HTML, under the columns they belong to --------------------------- */
  function captions(g, selected) {
    var h = "";
    for (var i = 0; i < g.cols.length; i++) {
      var c = g.cols[i], d = c.d, on = d.size === selected;
      h += '<div class="sc-cap' + (on ? " is-on" : "") + '" style="left:' + f(c.pct) +
           "%;width:" + f(Math.max(c.wpct, 16)) + '%">';
      h += '<span class="sc-cap-size">' + d.w + IN + " " + X + " " + d.h + IN + "</span>";
      h += '<span class="sc-cap-cm">' + d.cm[0] + " " + X + " " + d.cm[1] + " cm</span>";
      if (g.mode === "room" && !c.o) {
        h += '<span class="sc-cap-obj">a wall of its own</span>';
        h += '<span class="sc-cap-pct"><b>Statement size</b></span>';
        h += '<span class="sc-cap-cm">centre ' + Math.round(d.centre) + IN + " up</span>";
      } else if (g.mode === "room") {
        h += '<span class="sc-cap-obj">' + esc(c.o.label) + "</span>";
        h += '<span class="sc-cap-pct"><b>' + d.pct + "%</b> of its " + Math.round(c.o.back) + IN + " back</span>";
        h += '<span class="sc-cap-cm">centre ' + Math.round(d.centre) + IN + " up</span>";
      } else if (on) {
        h += '<span class="sc-cap-pct"><b>Your size</b></span>';
      }
      h += "</div>";
    }
    return h;
  }

  var merged = false;
  function render(root) {
    var M = window.ABS_FIT;
    if (!M) return;
    // The geometry ships in the asset; only Liquid knows the CDN paths, so it hands those over on
    // the page itself. Merge once.
    if (!merged) {
      var SRC = window.ABS_FIT_SRC || {};
      for (var k in M.objects) if (SRC[k]) M.objects[k].src = SRC[k];
      merged = true;
    }
    var names = (root.getAttribute("data-sizes") || "").split(",")
      .map(function (x) { return x.trim(); }).filter(Boolean);
    var list = [], i, p;
    for (i = 0; i < names.length; i++) {
      var d = M.sizes[names[i]];
      // A size with no pairing is a size the ladder does not cover. Skipping it silently is how a
      // block ends up quietly describing four of a product's five sizes, so it is reported.
      if (!d) { if (window.console) console.warn("[size-compare] no fit data for " + names[i]); continue; }
      var row = { size: names[i] };
      for (p in d) row[p] = d[p];
      list.push(row);
    }
    if (!list.length) { root.setAttribute("hidden", "hidden"); return; }
    list.sort(function (a, b) { return a.w * a.h - b.w * b.h; });

    var mount = root.getAttribute("data-mount") || "stretched";
    var selected = root.getAttribute("data-selected") || "";
    var mode = root.getAttribute("data-mode") || "room";
    var stage = root.querySelector("[data-sc-stage]");
    if (!stage) return;

    var gp = layoutPerson(list), gr = layoutRoom(list, M.standards, M.objects);
    // ONE VIEWBOX WIDTH FOR BOTH TABS, so switching tabs does not resize the band under the
    // reader's cursor. The narrower drawing is centred in the wider box.
    var W = Math.max(gp.W, gr.W);
    var g = mode === "person" ? gp : gr;

    var avail = stage.clientWidth || root.clientWidth || 900;
    var scale = Math.min(avail / W, MAX_H / g.H);
    if (scale < MIN_PX) scale = MIN_PX;                 // below this it scrolls rather than shrinks
    var wpx = Math.round(W * scale), hpx = Math.round(g.H * scale);

    var svg = '<svg viewBox="0 0 ' + f(W) + " " + f(g.H) + '" width="' + wpx + '" height="' + hpx +
      '" role="img" aria-label="' + esc(list.map(function (r) {
        return r.w + " by " + r.h + " inches"; }).join(", ")) + '">' +
      paint(g, mount, selected, scale, W) + "</svg>";

    stage.innerHTML = '<div class="sc-canvas" style="width:' + wpx + 'px">' + svg +
      '<div class="sc-caps">' + captions(g, selected) + "</div></div>";
    root.classList.toggle("sc-scrolls", wpx > avail + 2);
  }


  function normalise(v) {
    // ESCAPES, NOT LITERALS, and a real word boundary. The TGOA original carried a stray BACKSPACE
    // character where the boundary should be, so " in" was never stripped (harmless there: its size
    // buttons read "24x36"). ABS buttons read "24 x 18 in", so it must strip correctly here.
    return String(v || "").toLowerCase().replace(/\s*[x\u00d7]\s*/, "x").replace(/["\u2033\u2032]|\bin\b|\.|\s/g, "").trim();
  }
  function pick(root, value) {
    var v = normalise(value);
    if (!window.ABS_FIT || !window.ABS_FIT.sizes[v]) return;
    if (root.getAttribute("data-selected") === v) return;
    root.setAttribute("data-selected", v);
    render(root);
  }

  /* ---- the size picker: a tooltip on each button, and a way down to the drawing --------
   * The buttons say "24x36" and nothing else, which is the whole problem this block exists for -
   * a number with no referent. The tooltip answers it in place for a shopper who only wants a
   * second's reassurance, and the link takes the one who wants the evidence to the drawing.
   *
   * The tooltip is pointer-events:none on purpose. Putting the link INSIDE it meant the link was
   * only reachable while hovering the button, and moving towards it dismissed the tooltip. The
   * link belongs under the row, where it can be clicked.
   */
  function enhancePicker(root) {
    var M = window.ABS_FIT;
    if (!M) return;
    var btns = document.querySelectorAll("[data-option-value]");
    var rows = [], any = false;
    Array.prototype.forEach.call(btns, function (b) {
      var d = M.sizes[normalise(b.getAttribute("data-option-value"))];
      if (!d || b.querySelector(".sc-tip")) return;
      var o = d.obj ? M.objects[d.obj] : null;
      var tip = document.createElement("span");
      tip.className = "sc-tip";
      tip.innerHTML = "<b>" + d.cm[0] + " " + X + " " + d.cm[1] + " cm</b>" +
        (o ? "<i>" + d.pct + "% of a " + Math.round(o.back) + IN + " " + esc(o.label) + "</i>" : "<i>a statement size for a wall of its own</i>") +
        "<i>centre " + Math.round(d.centre) + IN + " from the floor</i>";
      b.appendChild(tip);
      b.classList.add("has-sc-tip");
      any = true;
      var row = b.parentNode;
      if (rows.indexOf(row) === -1) rows.push(row);
    });
    if (!any) return;
    rows.forEach(function (row) {
      if (row.parentNode.querySelector(".sc-jump")) return;
      var n = row.querySelectorAll(".has-sc-tip").length;
      // gb-ux 2026-10-26: the buy box already has a "Not sure of the size?" note; put the scale link inside it
      // instead of adding a second "Not sure?" prompt.
      var helpP = row.closest("form") && row.closest("form").querySelector(".abs-size-help p");
      if (helpP) {
        if (helpP.querySelector(".sc-jump-inline")) return;
        var il = document.createElement("a");
        il.className = "sc-jump-inline"; il.href = "#find-your-fit";
        il.innerHTML = "see " + (n > 1 ? "the sizes" : "this size") + " drawn to scale&nbsp;&darr;";
        il.addEventListener("click", function (e) {
          e.preventDefault();
          root.scrollIntoView({ behavior: "smooth", block: "start" });
          history.replaceState(null, "", "#find-your-fit");
        });
        helpP.appendChild(document.createTextNode(" You can also "));
        helpP.appendChild(il);
        helpP.appendChild(document.createTextNode("."));
        return;
      }
      var a = document.createElement("a");
      a.className = "sc-jump";
      a.href = "#find-your-fit";
      // The count is the whole point of the wording. "See every size to scale" is a feature
      // description; "Not sure? See all 4 sizes to scale" names the doubt the shopper is actually
      // having at that moment and tells them exactly how much work the answer is.
      // 26 Oct 2026: only some sizes carry a scale tip, so "all 3 sizes" read wrong beside 6 size buttons
      a.innerHTML = "Not sure? See " + (n > 1 ? "the sizes" : "this size") + " drawn to scale <b>&darr;</b>";
      a.addEventListener("click", function (e) {
        e.preventDefault();
        root.scrollIntoView({ behavior: "smooth", block: "start" });
        history.replaceState(null, "", "#find-your-fit");
      });
      row.parentNode.insertBefore(a, row.nextSibling);
    });
  }

  function wire(root) {
    var tabs = root.querySelectorAll("[data-sc-tab]");
    Array.prototype.forEach.call(tabs, function (btn) {
      btn.addEventListener("click", function () {
        root.setAttribute("data-mode", btn.getAttribute("data-sc-tab"));
        Array.prototype.forEach.call(tabs, function (b) {
          b.classList.toggle("is-on", b === btn);
          b.setAttribute("aria-selected", b === btn ? "true" : "false");
        });
        render(root);
      });
    });
    // The block FOLLOWS the variant picker rather than owning a selection of its own. Two size
    // controls on one page that can disagree with each other is worse than no highlight at all.
    //
    // TWO LISTENERS, BECAUSE THE PICKER IS NOT A FORM CONTROL. This theme's size picker is a row
    // of <button data-option-value>, not radios, so a "change" listener never fires and the
    // highlight silently froze on whatever the server rendered. The click handler is the one that
    // actually works here; the change handler stays for any template that does use inputs.
    document.addEventListener("change", function (e) {
      var t = e.target;
      if (!t || !t.name || t.name.toLowerCase().indexOf("size") === -1) return;
      pick(root, t.value);
    });
    document.addEventListener("click", function (e) {
      var b = e.target && e.target.closest && e.target.closest("[data-option-value]");
      if (b) pick(root, b.getAttribute("data-option-value"));
    });
    var t;
    window.addEventListener("resize", function () {
      clearTimeout(t); t = setTimeout(function () { render(root); }, 160);
    });
    render(root);
    enhancePicker(root);
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll("[data-size-compare]"), wire);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
